import { Box, Button, List, styled, Typography } from '@mui/material';
import {
  THANK_YOU_FOR_UPLOADING_DOCUMENTS,
  UPLOAD_MORE_BOTTOM_TEXT,
  UPLOAD_MORE_DOCUMENTS,
} from 'common/constants/process-management';
import theme from 'theme';
import CircularProgressWithLabel from '../CircularProgressWithLabel';
import { TaskCompletedBoxProps } from './TaskCompletedBox.props';

const PREFIX = 'TaskCompletedBox';

const classes = {
  taskCompleted: `${PREFIX}-taskCompleted`,
  taskCompletedText: `${PREFIX}-taskCompletedText`,
  completedFilesItem: `${PREFIX}-completedFilesItem`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.taskCompleted}`]: ({ isMobile }: { isMobile: boolean }) => ({
    marginTop: isMobile ? undefined : '1rem',
    borderWidth: isMobile ? undefined : '0 0.125rem 0.125rem 0.125rem',
    borderStyle: 'solid',
    borderColor: theme.palette.primary[900],
    borderRadius: isMobile ? undefined : '0.5rem',
    backgroundColor: theme.palette.primary[900],
    padding: isMobile ? undefined : '1.5rem 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    zIndex: isMobile ? undefined : 10000,
  }),

  [`& .${classes.taskCompletedText}`]: {
    color: theme.palette.common.black,
    fontSize: '1.125rem',
    fontWeight: 700,
    textAlign: 'center',
    marginTop: '1.5rem',
  },

  [`& .${classes.completedFilesItem}`]: {
    color: theme.palette.common.black,
    fontSize: '0.875rem',
  },
}));

const TaskCompletedBox = ({ progress, requestedFiles, isMobile, handleNeedToUploadMore }: TaskCompletedBoxProps) => (
  <StyledBox className={classes.taskCompleted}>
    <Box padding="0 3rem" display="flex" justifyContent="center" alignItems="flex-start" flexDirection="column">
      <Box margin="0 auto">
        <CircularProgressWithLabel
          progress={progress}
          numberStyles={{ fontSize: '1.35rem', color: theme.palette.black }}
          circleSize="5.375rem"
        />
      </Box>
      <Typography variant="h3" className={classes.taskCompletedText}>
        {THANK_YOU_FOR_UPLOADING_DOCUMENTS}
      </Typography>
      <List
        style={{
          listStyle: 'disc',
          margin: '0.5rem 0 0 1rem',
        }}>
        {requestedFiles.map(file => (
          <li key={file.id} className={classes.completedFilesItem}>
            {file.name}
          </li>
        ))}
      </List>
      <Button
        style={{
          backgroundColor: theme.palette.primary[500],
          color: theme.palette.white,
          fontWeight: '700',
          marginTop: '1.5rem',
          width: '100%',
          fontSize: '1.125rem',
          textTransform: 'none',
          textDecoration: `underline ${theme.palette.primary[500]}`,
          textUnderlinePosition: 'under',
        }}
        onClick={handleNeedToUploadMore}>
        {UPLOAD_MORE_DOCUMENTS}
      </Button>
      <Typography variant="h3" className={classes.completedFilesItem}>
        {UPLOAD_MORE_BOTTOM_TEXT}
      </Typography>
    </Box>
  </StyledBox>
);

export default TaskCompletedBox;
